/* ============================================================
   SCUSA® Theme — global JavaScript
   Site-wide behavior only: header nav (mobile drawer, dropdown,
   search), sticky nav shadow, add-to-cart for [data-atc] buttons,
   header cart-count badge, and back-to-top.
   Section-specific behavior (product PDP, cart, guides, configurator)
   lives in each section's own script, not here.
   ============================================================ */
(function(){
'use strict';

function qs(sel,ctx){return(ctx||document).querySelector(sel);}
function qsa(sel,ctx){return[...(ctx||document).querySelectorAll(sel)];}
function on(el,ev,fn){if(el)el.addEventListener(ev,fn);}

/* ── Mobile nav drawer ─────────────────────────────────────── */
function initMobileNav(){
  var drawer=qs('#nav-drawer');
  var overlay=qs('.nav__drawer-overlay');
  var closeBtn=qs('.nav__drawer-close');
  var hamburgers=qsa('.nav__hamburger');
  if(!drawer)return;
  function setHamburgerExpanded(open){hamburgers.forEach(function(btn){btn.setAttribute('aria-expanded',open?'true':'false');});}
  function openDrawer(){drawer.classList.add('open');document.body.style.overflow='hidden';setHamburgerExpanded(true);}
  function closeDrawer(){drawer.classList.remove('open');document.body.style.overflow='';setHamburgerExpanded(false);}
  hamburgers.forEach(function(btn){on(btn,'click',openDrawer);});
  on(closeBtn,'click',closeDrawer);
  on(overlay,'click',closeDrawer);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
}

/* ── Shop dropdown — click (touch-friendly) + hover, with aria-expanded ── */
function initDropdown(){
  var dropdowns=qsa('.nav--has-dropdown');
  function closeAll(except){
    dropdowns.forEach(function(d){
      if(d===except)return;
      d.classList.remove('open');
      var t=qs('.nav__dropdown-toggle',d);
      if(t)t.setAttribute('aria-expanded','false');
    });
  }
  dropdowns.forEach(function(item){
    var toggle=qs('.nav__dropdown-toggle',item);
    var menu=qs('.nav__dropdown',item);
    if(!toggle||!menu)return;
    var closeTimer=null;
    function open(){clearTimeout(closeTimer);closeAll(item);item.classList.add('open');toggle.setAttribute('aria-expanded','true');}
    function close(){item.classList.remove('open');toggle.setAttribute('aria-expanded','false');}
    // Delay close so the mouse can travel from toggle into the menu
    function closeSoon(){closeTimer=setTimeout(close,120);}
    on(toggle,'click',function(e){e.stopPropagation();item.classList.contains('open')?(clearTimeout(closeTimer),close()):open();});
    item.addEventListener('mouseenter',open);
    item.addEventListener('mouseleave',closeSoon);
    menu.addEventListener('mouseenter',function(){clearTimeout(closeTimer);});
    menu.addEventListener('mouseleave',closeSoon);
  });
  document.addEventListener('click',function(e){if(!e.target.closest('.nav--has-dropdown'))closeAll(null);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll(null);});
}

/* ── Search overlay — toggle, close button, Escape; aria-expanded synced ── */
function initSearch(){
  var toggleBtn=qs('[data-search-toggle]');
  var bar=qs('#nav-search');
  var input=qs('.nav__search-input');
  var closeBtns=qsa('[data-search-close]');
  if(!toggleBtn||!bar)return;
  function setOpen(open){
    bar.classList.toggle('open',open);
    toggleBtn.setAttribute('aria-expanded',open?'true':'false');
    if(open&&input)input.focus();
  }
  on(toggleBtn,'click',function(){setOpen(!bar.classList.contains('open'));});
  closeBtns.forEach(function(btn){on(btn,'click',function(){setOpen(false);});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&bar.classList.contains('open'))setOpen(false);});
}

/* ── Sticky nav shadow on scroll ───────────────────────────── */
function initNavShadow(){
  var nav=qs('.site-nav');
  if(!nav)return;
  function update(){nav.style.boxShadow=window.scrollY>10?'0 2px 20px rgba(0,0,0,.08)':'none';}
  window.addEventListener('scroll',update,{passive:true});
  update();
}

/* ── Add to cart — generic [data-atc] buttons (used by featured-products).
   Sections with their own cart logic (PDP, configurator) handle their own. ── */
function initAddToCart(){
  qsa('[data-atc]').forEach(function(btn){
    on(btn,'click',function(e){
      var variantId=btn.dataset.variantId||btn.dataset.atc;
      if(!variantId)return; // configurator buttons carry no id — they self-handle
      e.preventDefault();
      var form=btn.closest('form');
      var qty=form?parseInt((qs('.qty-input',form)||{}).value||1):1;
      var orig=btn.textContent;
      btn.disabled=true;
      btn.textContent='Adding...';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:variantId,quantity:qty})
      }).then(function(res){
        showToast(res.ok?'Added to cart! 🛒':'Something went wrong',res.ok?'success':'error');
        if(res.ok)updateCartCount();
      }).catch(function(){showToast('Please try again','error');})
      .finally(function(){btn.disabled=false;btn.textContent=orig;});
    });
  });
}

/* ── Header cart-count badge ────────────────────────────────── */
function updateCartCount(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    qsa('.nav__cart-count').forEach(function(el){
      el.textContent=cart.item_count;
      el.style.display=cart.item_count>0?'flex':'none';
    });
    window.SCUSA_CART_TOTAL=cart.total_price;
  }).catch(function(){});
}

/* ── Toast ─────────────────────────────────────────────────── */
function showToast(msg,type){
  var toast=qs('#main-toast');
  if(!toast){
    toast=document.createElement('div');
    toast.id='main-toast';
    document.body.appendChild(toast);
  }
  toast.className='toast toast--'+(type||'success');
  toast.textContent=msg;
  requestAnimationFrame(function(){
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer=setTimeout(function(){toast.classList.remove('show');},3000);
  });
}

/* ── Back to top ───────────────────────────────────────────── */
function initBackToTop(){
  var btn=qs('[data-back-to-top]');
  if(!btn)return;
  window.addEventListener('scroll',function(){
    var show=window.scrollY>500;
    btn.style.opacity=show?'1':'0';
    btn.style.pointerEvents=show?'auto':'none';
  },{passive:true});
  on(btn,'click',function(){window.scrollTo({top:0,behavior:'smooth'});});
}

document.addEventListener('DOMContentLoaded',function(){
  initMobileNav();
  initDropdown();
  initSearch();
  initNavShadow();
  initAddToCart();
  initBackToTop();
  updateCartCount();
});

})();
